import { render, staticRenderFns } from "./SchemaPicker.vue?vue&type=template&id=44be33c6&scoped=true"
import script from "./SchemaPicker.vue?vue&type=script&lang=js"
export * from "./SchemaPicker.vue?vue&type=script&lang=js"
import style0 from "./SchemaPicker.vue?vue&type=style&index=0&id=44be33c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44be33c6",
  null
  
)

export default component.exports